import React from 'react';
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import chipStyle from './style/chipStyle';

const s = chipStyle;

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => !['bold', 'sep', 'small', 'chipColor'].includes(prop),
})(({ bold, sep, small, chipColor }) => ({
  ...(bold && s.bold),
  ...(sep && s.sep),
  ...(small && s.small),
  ...(chipColor && s[`${chipColor}Color`]),
  '&.MuiChip-root': {
    ...s[`${chipColor}Color`],
    ...s.root,
  },
}));

const CustomChip = ({ className, bold, sep, small, color = 'lightGray', children, ...restProps }) => (
  <StyledChip
    label={children}
    className={className}
    bold={bold}
    sep={sep}
    small={small}
    chipColor={color}
    {...restProps}
  />
);

CustomChip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  bold: PropTypes.bool,
  sep: PropTypes.bool,
  small: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'secondary', 'red', 'yellow', 'purple', 'orange', 'pink', 'lightGray']),
};

export default CustomChip;
